<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>奖券管理</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input placeholder="奖券ID" clearable v-model="id" size="mini">
              </el-input>
            </div>
          </div>

          <div class="item">
            <div class="ipt">
              <el-select
                v-model="status"
                placeholder="状态"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in typeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <Add
              v-if="$hasPerm('tenant:activity_lottery:add_lottery')"
              @refresh="refreshList"
            />
          </div>
          <div class="item">
            <Extraction
              v-if="$hasPerm('tenant:activity_lottery:extraction_threshold')"
              @refresh="refreshList"
            />
          </div>
          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
            <el-button size="mini" type="primary" @click="handleClearSearch"
              >重置</el-button
            >
          </div>
        </div>
        <div class="pl_total_box">
          <div class="pl_total">
            <span>当前阈值</span>
            <span></span>
            <span>{{ lotteryConfig.userOpThreshold | fixD(6) }}</span>
            <span>{{ lotteryConfig.userOpThresholdCoin }}</span>
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import './store'
import UserList from './components/list'
import Add from './components/add'
import Extraction from './components/extraction'
import { mapState, mapActions, mapMutations } from 'vuex'
import { QUERY_TYPE, PAGINATION } from './constants'
import api from './api'
import moment from 'moment'
export default {
  name: 'UnderUser',
  components: {
    UserList,
    Add,
    Extraction,
  },
  data() {
    return {
      dialogVisible: false,
      id: '',
      status: '',

      totalAmount: 0,
      typeArr: [
        { value: 0, label: '关闭' },
        { value: 1, label: '激活' },
      ],
    }
  },
  computed: {
    ...mapState('activityLottery', [
      'queryType',
      'pagination',
      'lotteryConfig',
    ]),
    ...mapState(['userInfo']),
  },
  methods: {
    ...mapActions('activityLottery', [
      'list',
      'addUser',
      'addLottery',
      'getLotteryConfig',
    ]),
    ...mapMutations('activityLottery', ['setQueryType']),
    refreshList(data = {}) {
      this.handleSearch(data)
    },

    handleSearch(data) {
      this.list({
        id: this.id,
        status: this.status,
        ...PAGINATION,
        ...data,
      })
    },
    handleClearSearch() {
      this.status = ''
      this.id = ''
      this.list({
        ...PAGINATION,
      })
    },

    closeDialog() {
      this.dialogVisible = false
    },
    onOpen() {},
    onClose() {
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    exportData() {
      const data = {
        id: this.id,
        status: this.status,
        page: this.pagination.page,
        size: this.pagination.size,
      }
      api.getExcelData(data).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
        link.style.display = 'none'
        // 设置连接
        link.href = URL.createObjectURL(blob) //将文件流转化为blob地址

        link.download = '返佣列表'
        document.body.appendChild(link)
        // 模拟点击事件
        link.click() //设置点击事件
      })
    },
  },
  mounted() {
    this.getLotteryConfig()
    this.handleSearch()
  },
}
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
